export default __webpack_public_path__ + "static/coinbase_bg-ab4885c9035fbfb38b5dd433812c63f8.png";